import { DateTime } from 'luxon';
import type { IMonitorReplay } from '@interfaces/IMonitorApi';

/** The knob's hit area; the time axis is inset by half of it so the knob never leaves the track. */
export const KNOB_HIT_PX = 24;
export const TRACK_INSET_PX = KNOB_HIT_PX / 2;

/** The instant under a pointer `x` px into a track `trackWidth` wide: clamped to the window start and the data end. */
export function pointerMs(x: number, trackWidth: number, start: number, end: number, dataEnd: number) {
  const ms = start + ((x - TRACK_INSET_PX) / (trackWidth - 2 * TRACK_INSET_PX)) * (end - start);
  return Math.min(Math.max(ms, start), dataEnd);
}

/** The track's window as instants, and an instant's position on it in %. */
export function dayScale(replay: IMonitorReplay) {
  const start = Date.parse(replay.window.start);
  const end = Date.parse(replay.window.end);
  return {
    start,
    end,
    /** The data end, never past the window. */
    dataEnd: Math.min(Date.parse(replay.dataEnd), end),
    percentAt: (ms: number) => ((ms - start) / (end - start)) * 100,
  };
}

/** `HH:mm` in the site zone. */
export const siteClock = (ms: number, tz: string) => DateTime.fromMillis(ms, { zone: tz }).toFormat('HH:mm');
